import { EmojiConvertor } from 'emoji-js';

// emoji-js 인스턴스 생성 및 설정
const emoji = new EmojiConvertor();
emoji.replace_mode = 'unified'; // 이모지 출력 모드 설정
emoji.allow_native = true; // 네이티브 이모지 사용

/**
 * 텍스트에 포함된 이모지 코드(:code:)를 실제 이모지로 변환
 * @param text 변환할 텍스트
 * @returns 이모지가 변환된 텍스트
 *
 * @example
 * formatEmojiText("안녕하세요 :hugging_face:") // "안녕하세요 🤗"
 * formatEmojiText("좋아요 :heart:") // "좋아요 ❤️"
 */
export const formatEmojiText = (text: string) => {
  if (!text) return text;

  try {
    return emoji.replace_colons(text);
  } catch {
    return text;
  }
};
